import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Fraction } from '@uniswap/sdk-core'
import JSBI from 'jsbi'
import React, { useCallback, useState } from 'react'
import Tilt from 'react-parallax-tilt'
import styled, { keyframes } from 'styled-components/macro'

import BronzeNFT from '../../assets/bronze-nft.png'
import DiamondNFT from '../../assets/diamond-nft.png'
import GoldNFT from '../../assets/gold-nft.png'
import PlebNFT from '../../assets/pleb-nft.png'
import SilverNFT from '../../assets/silver-nft.png'
import UnknownNFT from '../../assets/unknown-nft.gif'
import useActiveWeb3React from '../../hooks/useActiveWeb3React'
import { useTotalSupply } from '../../hooks/useTotalSupply'
import useUselessToken from '../../hooks/useUselessToken'
import { IntegerInput } from '../../lib/components/Input'
import { useMintCallback } from '../../lib/hooks/swap/useMintCallback'
import { useWalletModalToggle } from '../../state/application/hooks'
import { TransactionType } from '../../state/transactions/actions'
import { useTransactionAdder } from '../../state/transactions/hooks'

const PageWrapper = styled.div`
  width: calc(100% - 80px);
  max-width: 100vw;
  overflow: hidden;
  padding: 0 40px;

  @media screen and (max-width: 500px) {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
`

const TopSection = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 100px;
  margin-top: 10vh;
`

const TitleWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  display: inline-block;
  margin-bottom: 50px;
`

const SloganText = styled.div`
  font-weight: 400;
  font-size: 64px;
  margin-bottom: 20px;

  @media screen and (max-width: 780px) {
    font-size: 56px;
  }

  @media screen and (max-width: 680px) {
    font-size: 42px;
  }

  @media screen and (max-width: 580px) {
    width: 260px;
    margin: 0 auto;
    transform: translateY(-125px);
  }

  @media screen and (max-width: 450px) {
    transform: translateY(-115px);
  }
`

const SubtitleText = styled.div`
  font-weight: 200;
  font-size: 17px;
  margin-bottom: 15px;

  @media screen and (max-width: 600px) {
    font-size: 15px;
  }

  @media screen and (max-width: 580px) {
    margin-top: 20px;
  }
`

const carousel = keyframes`
  from {
    transform: translateX(200px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(200px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(400px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(200px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel880 = keyframes`
  from {
    transform: translateX(180px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(180px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(360px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(180px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel780 = keyframes`
  from {
    transform: translateX(150px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(150px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(300px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(150px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel580 = keyframes`
  from {
    transform: translateX(125px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(125px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(250px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(125px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel450 = keyframes`
  from {
    transform: translateX(100px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(100px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(200px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(100px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  text-align: center;
  margin: -70px auto 20px;
  position: relative;
  height: 200px;

  img {
    position: absolute;
    animation-name: ${carousel};
    animation-duration: 20s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    width: 200px;
    height: 200px;
    margin-left: -290px;
    border-radius: 18px;

    :nth-of-type(1) {
      animation-delay: 0s;
    }

    :nth-of-type(2) {
      animation-delay: -4s;
    }

    :nth-of-type(3) {
      animation-delay: -8s;
    }

    :nth-of-type(4) {
      animation-delay: -12s;
    }

    :nth-of-type(5) {
      animation-delay: -16s;
    }
  }

  @media screen and (max-width: 880px) {
    margin: -65px auto 5px;

    img {
      width: 180px;
      height: 180px;
      margin-left: -270px;
      border-radius: 15px;
      animation-name: ${carousel880};
    }
  }

  @media screen and (max-width: 780px) {
    margin: -65px auto -35px;

    img {
      width: 150px;
      height: 150px;
      margin-left: -225px;
      border-radius: 12px;
      animation-name: ${carousel780};
    }
  }

  @media screen and (max-width: 580px) {
    margin: -65px auto -60px;
    transform: translateY(125px);

    img {
      width: 125px;
      height: 125px;
      margin-left: -187px;
      border-radius: 10px;
      animation-name: ${carousel580};
    }
  }

  @media screen and (max-width: 450px) {
    margin: -65px auto -80px;

    img {
      width: 100px;
      height: 100px;
      margin-left: -150px;
      border-radius: 10px;
      animation-name: ${carousel450};
    }
  }
`

const InfoSection = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  margin-bottom: 60px;
`

const InfoSectionSide = styled.div`
  width: 100%;
  margin-bottom: 60px;
  display: inline-block;

  @media screen and (max-width: 600px) {
    text-align: center;
  }

  @media screen and (max-width: 450px) {
    :nth-of-type(2) > div:nth-of-type(2) {
      margin-top: -35px;
    }
  }
`

const TopImage = styled.div`
  width: 50%;
  text-align: center;
  display: inline-block;
  vertical-align: top;

  > * {
    height: 180px;

    @media screen and (max-width: 1000px) {
      height: 150px;
    }
  }

  @media screen and (max-width: 880px) {
    width: 45%;
    min-width: 260px;
  }

  @media screen and (max-width: 680px) {
    width: 50%;
    margin-top: 20px;
  }

  @media screen and (max-width: 600px) {
    width: 70%;
    margin: 0 auto;
  }

  @media screen and (max-width: 450px) {
    width: 90%;
  }
`

const InfoContentWrapper = styled.div`
  width: 45%;
  display: inline-block;
  vertical-align: top;
  padding-left: 5%;

  @media screen and (max-width: 880px) {
    width: 52%;
    padding-left: 3%;
  }

  @media screen and (max-width: 680px) {
    width: 42%;
    padding-left: 4%;
  }

  @media screen and (max-width: 600px) {
    width: 70%;
    margin: 0 auto;
    padding: 0;
  }

  @media screen and (max-width: 450px) {
    width: 90%;
  }
`

const InfoTitle = styled.div`
  width: 100%;
  font-weight: 400;
  font-size: 28px;
  margin-top: 5px;
  margin-bottom: 6px;

  @media screen and (max-width: 1000px) {
    font-size: 24px;
    margin-top: 0;
  }

  @media screen and (max-width: 600px) {
    font-size: 28px;
    margin-top: 20px;
  }
`

const InfoContent = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 200;
  line-height: 25px;

  @media screen and (max-width: 1000px) {
    font-size: 16px;
    line-height: 22px;
  }

  @media screen and (max-width: 880px) {
    font-size: 15px;
    line-height: 21px;
  }

  @media screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 50px;
  }

  @media screen and (max-width: 450px) {
    font-size: 15px;
    line-height: 21px;
  }
`

const NFTsImageWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  height: 200px;
  margin-bottom: 100px;
  margin-top: 0px;

  @media screen and (max-width: 600px) {
    margin-bottom: -20px;
  }
`

const NFTsImageInner = styled.div`
  width: 180px;
  height: 180px;
  display: inline-block;
  position: relative;

  img {
    width: 180px;
    height: 180px;
    position: absolute;
    left: 0;
    top: 0;

    :nth-of-type(1) {
      z-index: 5;
    }

    :nth-of-type(2) {
      z-index: 4;
      transform: rotate(-16deg);
      height: 150px;
      width: 150px;
      top: 20px;
      left: -70px;
    }

    :nth-of-type(3) {
      z-index: 3;
      transform: rotate(16deg);
      height: 150px;
      width: 150px;
      top: 20px;
      left: 100px;
    }

    :nth-of-type(4) {
      z-index: 2;
      transform: rotate(-32deg);
      height: 120px;
      width: 120px;
      top: 60px;
      left: -120px;
    }

    :nth-of-type(5) {
      z-index: 1;
      transform: rotate(32deg);
      height: 120px;
      width: 120px;
      top: 60px;
      left: 180px;
    }
  }

  @media screen and (max-width: 1000px) {
    width: 150px;
    height: 150px;
    margin-top: 12px;

    img {
      width: 150px;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;

      :nth-of-type(1) {
        z-index: 5;
      }

      :nth-of-type(2) {
        z-index: 4;
        transform: rotate(-16deg);
        height: 125px;
        width: 125px;
        top: 17px;
        left: -58px;
      }

      :nth-of-type(3) {
        z-index: 3;
        transform: rotate(16deg);
        height: 125px;
        width: 125px;
        top: 17px;
        left: 83px;
      }

      :nth-of-type(4) {
        z-index: 2;
        transform: rotate(-32deg);
        height: 100px;
        width: 100px;
        top: 50px;
        left: -100px;
      }

      :nth-of-type(5) {
        z-index: 1;
        transform: rotate(32deg);
        height: 100px;
        width: 100px;
        top: 50px;
        left: 150px;
      }
    }
  }

  @media screen and (max-width: 880px) {
    width: 100px;
    height: 100px;
    margin-top: 30px;

    img {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
      top: 0;

      :nth-of-type(1) {
        z-index: 5;
      }

      :nth-of-type(2) {
        z-index: 4;
        transform: rotate(-16deg);
        height: 87px;
        width: 87px;
        top: 11px;
        left: -38px;
      }

      :nth-of-type(3) {
        z-index: 3;
        transform: rotate(16deg);
        height: 87px;
        width: 87px;
        top: 11px;
        left: 55px;
      }

      :nth-of-type(4) {
        z-index: 2;
        transform: rotate(-32deg);
        height: 66px;
        width: 66px;
        top: 32px;
        left: -66px;
      }

      :nth-of-type(5) {
        z-index: 1;
        transform: rotate(32deg);
        height: 66px;
        width: 66px;
        top: 32px;
        left: 100px;
      }
    }
  }

  @media screen and (max-width: 600px) {
    width: 150px;
    height: 150px;
    margin-top: 12px;

    img {
      width: 150px;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;

      :nth-of-type(1) {
        z-index: 5;
      }

      :nth-of-type(2) {
        z-index: 4;
        transform: rotate(-16deg);
        height: 125px;
        width: 125px;
        top: 17px;
        left: -58px;
      }

      :nth-of-type(3) {
        z-index: 3;
        transform: rotate(16deg);
        height: 125px;
        width: 125px;
        top: 17px;
        left: 83px;
      }

      :nth-of-type(4) {
        z-index: 2;
        transform: rotate(-32deg);
        height: 100px;
        width: 100px;
        top: 50px;
        left: -100px;
      }

      :nth-of-type(5) {
        z-index: 1;
        transform: rotate(32deg);
        height: 100px;
        width: 100px;
        top: 50px;
        left: 150px;
      }
    }
  }

  @media screen and (max-width: 450px) {
    width: 100px;
    height: 100px;
    margin-top: 30px;

    img {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
      top: 0;

      :nth-of-type(1) {
        z-index: 5;
      }

      :nth-of-type(2) {
        z-index: 4;
        transform: rotate(-16deg);
        height: 87px;
        width: 87px;
        top: 11px;
        left: -38px;
      }

      :nth-of-type(3) {
        z-index: 3;
        transform: rotate(16deg);
        height: 87px;
        width: 87px;
        top: 11px;
        left: 55px;
      }

      :nth-of-type(4) {
        z-index: 2;
        transform: rotate(-32deg);
        height: 66px;
        width: 66px;
        top: 32px;
        left: -66px;
      }

      :nth-of-type(5) {
        z-index: 1;
        transform: rotate(32deg);
        height: 66px;
        width: 66px;
        top: 32px;
        left: 100px;
      }
    }
  }
`

const GraphicSection = styled.div`
  width: fit-content;
  margin: 20px auto;
  text-align: center;
`

const GraphicInner = styled.div`
  width: fit-content;
  margin: 0 -10px 0 0;
  padding-right: 22px;
  display: inline-block;
  vertical-align: top;

  @media screen and (max-width: 600px) {
    padding: 0;
  }
`

const PurchaseTop = styled.div``

const SaleImage = styled.div`
  width: 100%;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  position: relative;

  img {
    width: 350px;
    height: 350px;
  }

  > div > div:nth-of-type(2) {
    border-radius: 25px !important;
  }

  @media screen and (max-width: 1000px) {
    margin-top: 30px;
    img {
      width: 280px;
      height: 280px;
    }

    > div {
      width: 280px !important;
      height: 280px !important;
      border-radius: 20px !important;
    }
  }

  @media screen and (max-width: 880px) {
    margin-top: 35px;
    img {
      width: 250px;
      height: 250px;
    }

    > div {
      width: 250px !important;
      height: 250px !important;
      border-radius: 16px !important;
    }
  }

  @media screen and (max-width: 780px) {
    margin-top: 55px;
    img {
      width: 200px;
      height: 200px;
    }

    > div {
      width: 200px !important;
      height: 200px !important;
      border-radius: 12px !important;
    }
  }
`

const PurchasePanel = styled.div`
  width: 350px;
  display: inline-block;
  vertical-align: top;
  text-align: left;
  padding-left: 50px;
  margin-top: 5px;
  margin-bottom: 150px;
  padding-top: 25px;

  @media screen and (max-width: 880px) {
    padding-left: 20px;
  }

  @media screen and (max-width: 780px) {
    padding-left: 10px;
    width: 300px;
  }

  @media screen and (max-width: 600px) {
    width: 90%;
    padding-top: 10px;
    padding-left: 0;
  }
`

const PurchaseTitle = styled.div`
  font-size: 60px;
  font-weight: 400;
  margin-bottom: 10px;
  margin-left: -2px;

  @media screen and (max-width: 880px) {
    font-size: 52px;
    margin-bottom: 5px;
  }
`

const PurchaseSubtitle = styled.div`
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 30px;
  font-weight: 200;

  @media screen and (max-width: 880px) {
    font-size: 15px;
    line-height: 21px;
  }

  @media screen and (max-width: 780px) {
    margin-bottom: 20px;
  }
`

const InputSection = styled.div`
  width: 300px;

  @media screen and (max-width: 600px) {
    float: right;
    width: 245px;
  }
`

const InputFieldWrapper = styled.div`
  margin: fit-content;
  padding: 9px 25px 11px;
  background: ${({ theme }) => theme.text1};
  color: black;
  border-radius: 8px;
  height: 35px;
  width: 110px;
  display: inline-block;
  vertical-align: top;
  position: relative;

  input {
    font-size: 28px;
    text-align: right;
  }

  @media screen and (max-width: 780px) {
    padding: 7px 20px 9px;
    height: 32px;
    width: 130px;

    input {
      font-size: 25px;
    }
  }

  @media screen and (max-width: 600px) {
    width: 62px;
    height: 36px;
    padding: 8px 24px 12px;

    input {
      font-size: 30px;
    }
  }
`

const RemainingNFTsNoAlignment = styled.div`
  font-size: 13px;
  font-weight: 300;
  width: fit-content;
  margin-top: 3px;
  width: 300px;

  @media screen and (max-width: 600px) {
    width: 245px;
  }
`

const RemainingNFTs = styled.div`
  text-align: right;
  font-size: 13px;
  font-weight: 300;
  width: fit-content;
  margin-top: 3px;
  width: 300px;

  @media screen and (max-width: 600px) {
    width: 245px;
  }
`

const InputButtons = styled.div`
  position: absolute;
  top: 0;
  right: -30px;
  height: 55px;
  width: 40px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow: hidden;

  @media screen and (max-width: 780px) {
    height: 48px;
  }

  @media screen and (max-width: 600px) {
    height: 56px;
  }
`

const InputButton = styled.div`
  width: 100%;
  background-color: #9ea1ab;
  cursor: pointer;
  height: 27.5px;
  text-align: center;
  line-height: 27.5px;

  :hover {
    background-color: #babcc3;
  }

  :active {
    background-color: #727683;
  }

  @media screen and (max-width: 780px) {
    height: 24px;
  }

  @media screen and (max-width: 600px) {
    height: 33px;
  }
`

const UpButton = styled(InputButton)``

const DownButton = styled(InputButton)``

const ConnectWalletButtonWrapper = styled.div`
  text-align: center;
`

const SubmitButton = styled.div<{ disabled: boolean }>`
  border-radius: 10px;
  border: 3px solid ${({ theme, disabled }) => (disabled ? theme.text3 : theme.text1)};
  color ${({ theme, disabled }) => (disabled ? theme.text3 : theme.text1)};
  font-size: 20px;
  padding: 12px 25px;
  width: fit-content;
  float: right;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  user-select: none;
  ${({ disabled }) => disabled && 'pointer-events: none;'}

  ${({ theme, disabled }) =>
    !disabled &&
    `:hover {\n    background-color: ${theme.text1};\n    color: #24232a;\n  }`} @media screen and(max-width: 780 px) {
    font-size: 17.5px;
    padding: 10px 22px;
  }

  @media screen and (max-width: 600px) {
    font-size: 21px;
    padding: 12px 24px;
  }
`

const ConnectWalletButton = styled.div`
  border-radius: 10px;
  border: 3px solid ${({ theme }) => theme.text1};
  color ${({ theme }) => theme.text1};
  font-size: 20px;
  padding: 12px 25px;
  width: fit-content;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  user-select: none;

  ${({ theme }) =>
    `:hover {\n    background-color: ${theme.text1};\n    color: #24232a;\n  }`} @media screen and(max-width: 780 px) {
  font-size: 17.5px;
  padding: 10px 22px;
}

  
  @media screen and (max-width: 600px) {
    font-size: 21px;
    padding: 12px 24px;
  }
`
export default function Buy() {
  const [numberToBuy, setNumberToBuy] = useState('1')
  const [{ amountBeingBought, mintErrorMessage, attemptingTxn, txHash }, setMintState] = useState<{
    amountBeingBought: number | undefined
    mintErrorMessage: string | undefined
    attemptingTxn: boolean
    txHash: string | undefined
  }>({
    amountBeingBought: undefined,
    mintErrorMessage: undefined,
    attemptingTxn: false,
    txHash: undefined,
  })
  const { account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()

  const uselessToken = useUselessToken()
  const totalSupply = useTotalSupply(uselessToken)
  const maxSupply = new Fraction('10000')
  const max_purchase_size = 5
  const remainingNFTs = totalSupply ? maxSupply.subtract(totalSupply) : new Fraction('0')

  const addTransaction = useTransactionAdder()
  const { callback: mintCallback, error: mintCallbackError } = useMintCallback({ amount: parseInt(numberToBuy) })

  const handleMint = useCallback(() => {
    if (!mintCallback) {
      return
    }
    setMintState({
      attemptingTxn: true,
      amountBeingBought: parseInt(numberToBuy),
      mintErrorMessage: undefined,
      txHash: undefined,
    })
    mintCallback()
      .then((response) => {
        setMintState({
          attemptingTxn: false,
          amountBeingBought: undefined,
          mintErrorMessage: undefined,
          txHash: response.hash,
        })
        addTransaction(response, {
          type: TransactionType.MINT,
          amount: Number.isNaN(parseInt(numberToBuy)) ? 0 : parseInt(numberToBuy),
        })
      })
      .catch((error) => {
        setMintState({
          attemptingTxn: false,
          amountBeingBought: undefined,
          mintErrorMessage: error.message,
          txHash: undefined,
        })
      })
  }, [addTransaction, mintCallback, numberToBuy])

  return (
    <PageWrapper>
      <TopSection>
        <ImageWrapper>
          <img src={DiamondNFT} />
          <img src={GoldNFT} />
          <img src={SilverNFT} />
          <img src={BronzeNFT} />
          <img src={PlebNFT} />
        </ImageWrapper>
        <TitleWrapper>
          <SloganText>Get your Useless NFT</SloganText>
          <SubtitleText>{`Why? Why on Earth would you purchase this?`}</SubtitleText>
        </TitleWrapper>
      </TopSection>
      <InfoSection>
        <InfoSectionSide>
          <TopImage>
            <img src={UnknownNFT} />
          </TopImage>
          <InfoContentWrapper>
            <InfoTitle>Phase One</InfoTitle>
            <InfoContent>
              Before all the Useless NFTs are minted, your NFT&apos;s tier is undecided and is represented by this
              question mark gif. For all we know, this may be your NFT forever, because what are the odds all of the
              Useless NFTs are minted?
            </InfoContent>
          </InfoContentWrapper>
        </InfoSectionSide>
        <InfoSectionSide>
          <TopImage>
            <NFTsImageWrapper>
              <NFTsImageInner>
                <img src={DiamondNFT} />
                <img src={GoldNFT} />
                <img src={SilverNFT} />
                <img src={BronzeNFT} />
                <img src={PlebNFT} />
              </NFTsImageInner>
            </NFTsImageWrapper>
          </TopImage>
          <InfoContentWrapper>
            <InfoTitle>Phase Two</InfoTitle>
            <InfoContent>
              After all Useless NFTs have been minted, your NFT will change based on the tier you&apos;re randomly
              assigned, meaning you can find out if you wasted your ETH and ended up with a pleb tier NFT, or lucked out
              and got a diamond tier NFT (which is no less of a waste of ETH).
            </InfoContent>
          </InfoContentWrapper>
        </InfoSectionSide>
      </InfoSection>
      <GraphicSection>
        <GraphicInner>
          <PurchaseTop>
            <SaleImage>
              <Tilt
                tiltReverse={true}
                tiltMaxAngleX={15}
                tiltMaxAngleY={15}
                glareEnable={true}
                style={{ width: 'fit-content', borderRadius: '24px', overflow: 'hidden' }}
              >
                <img style={{ marginBottom: '-4px' }} src={UnknownNFT} />
              </Tilt>
            </SaleImage>
          </PurchaseTop>
        </GraphicInner>
        <PurchasePanel>
          <PurchaseTitle>Mint</PurchaseTitle>
          <PurchaseSubtitle>
            Until all the Useless NFTs have been minted, you can mint your own Useless NFTs for 0.0569 ETH each. After
            all 10,000 have been minted, the tier of your Useless NFTs will be revealed.
          </PurchaseSubtitle>
          <InputSection>
            {account && (
              <InputFieldWrapper>
                <IntegerInput value={numberToBuy} onChange={(value) => setNumberToBuy(value)} />
                <InputButtons>
                  <UpButton onClick={() => setNumberToBuy('' + (parseInt(numberToBuy) + 1))}>
                    <KeyboardArrowUpIcon />
                  </UpButton>
                  <DownButton
                    onClick={() => setNumberToBuy('' + (numberToBuy !== '0' ? parseInt(numberToBuy) - 1 : numberToBuy))}
                  >
                    <KeyboardArrowDownIcon />
                  </DownButton>
                </InputButtons>
              </InputFieldWrapper>
            )}
            {!account ? (
              <ConnectWalletButtonWrapper>
                <ConnectWalletButton onClick={toggleWalletModal}>Connect Wallet</ConnectWalletButton>
                <RemainingNFTsNoAlignment>
                  {totalSupply ? maxSupply.subtract(totalSupply).toFixed(0, { groupSeparator: ',' }) : '10,000'}/10,000
                  remaining
                </RemainingNFTsNoAlignment>
              </ConnectWalletButtonWrapper>
            ) : (
              <SubmitButton
                disabled={
                  !(
                    numberToBuy !== '' &&
                    remainingNFTs.greaterThan('0') &&
                    parseInt(numberToBuy) <= max_purchase_size &&
                    JSBI.greaterThanOrEqual(remainingNFTs.quotient, JSBI.BigInt(numberToBuy))
                  )
                }
                onClick={() => handleMint()}
              >
                Mint
              </SubmitButton>
            )}
            {account && (
              <RemainingNFTs>
                {totalSupply ? maxSupply.subtract(totalSupply).toFixed(0, { groupSeparator: ',' }) : '10,000'}/10,000
                remaining
              </RemainingNFTs>
            )}
          </InputSection>
        </PurchasePanel>
      </GraphicSection>
    </PageWrapper>
  )
}
